import { useEffect } from 'react'

import { useAppDispatch } from '@/redux/rootReducer'
import { getConsultation, joinConsultationSocketEvent, leaveConsultationSocketEvent } from '@/redux/reducers/consultation.reducer'
import { getRoom } from '@/redux/reducers/room.reducer'
import { Consultation } from '@/core/models/consultation.model'

export function useConsultationLifecycle(consultationId?: string, consultation?: Consultation) {
  const dispatch = useAppDispatch()

  /**
   * @deprecated remove when useGetConsultationQuery is used everywhere instead of useAppSelector(selectConsultationById)
   */
  // Fetch consultation if not already in store
  useEffect(() => {
    if (!consultationId || consultation) return

    dispatch(getConsultation(consultationId))
  }, [dispatch, consultationId, consultation])

  // Fetch room and manage socket connection
  useEffect(() => {
    if (!consultationId) return

    dispatch(getRoom(consultationId))
    dispatch(joinConsultationSocketEvent(consultationId))

    return () => {
      dispatch(leaveConsultationSocketEvent(consultationId))
    }
  }, [dispatch, consultationId])
}
